(function($, B) {

B.web.polls={
    options : {
        duration: 500,
        sendAll: true,
        notVotedClass: 'not-voted',
        pollErrorClass:'poll-error',
        selectors: {
            form:'form.wp-polls-form',
            pollError: '.poll-error strong',
            formIdPrefix: 'polls_form_',
            input: 'input:checkbox, input:radio,  option',
            nonce: '[name=wp-polls-nonce]'
        }
    },
    getAnswers: function($pollForm){
        var o = this.options,
            values =[];
        $pollForm.find(o.selectors.input).each(function(i){
            var $ans = $(this);
            if ($ans.is(':checked') || $ans.is(':selected')) {
                values.push($ans.val());
            }
        });    
        return values;
    },  
    voteAll:function(){
        this.vote('all');
    },  
    vote: function($pollForms){  
        var that = this,
            o = this.options,
            filledPolls = [];
        if(!B.obj.is$($pollForms)){                
            $pollForms = $pollForms == 'all' 
                ? $(o.selectors.form)
                : $('#' + o.selectors.formIdPrefix + $pollForms);
        }
        $pollForms.each(function(){
            var $form = $(this),
                values = that.getAnswers($form);
            $form.removeClass(o.pollErrorClass);
            if(values.length > 0){
                $form.removeClass(o.notVotedClass);
                filledPolls.push({
                    poll: $form,
                    values: values
                });
                // that.process($form, values);
            }else{
                $form.addClass(o.notVotedClass);
                // console.log('pollsL10n.text_valid');
            }
        });
        if(!o.sendAll || $pollForms.length  == filledPolls.length){
            for(var i= 0; i< filledPolls.length; i++ ){
                this.process(filledPolls[i].poll, filledPolls[i].values);
            }
        }else{
            alert('Bardzo prosimy o udzielenie odpowiedzi na wszystkie pytania w ankiecie');
        }
    },
    process:function($pollForm, values){
        var o = this.options,
            current_poll_id = $pollForm.attr('id').replace(o.selectors.formIdPrefix, ''),
            $container = $pollForm.parent(),
            $loading = $('#' + $container.attr('id') + '-loading'),
            poll_nonce = ($pollForm.find(o.selectors.nonce)).val();
            if(pollsL10n.show_loading) {
                $loading.slideDown();                    
            }
        $.ajax({
            type: 'POST', 
            xhrFields: {withCredentials: true}, 
            url: pollsL10n.ajax_url, 
            data: 'action=polls&view=process&poll_id=' + current_poll_id + '&poll_' + current_poll_id + '=' + values.join(',') + '&poll_' + current_poll_id + '_nonce=' + poll_nonce, 
            cache: false, 
            success: function(data){
                if(pollsL10n.show_loading) {
                    $loading.slideUp(o.duration);
                }   
                var $result = $(data);
                if(!B.obj.is$($result)){
                    $pollForm
                        .addClass(o.pollErrorClass)
                        .find(o.selectors.pollError).html(data);
                    return;
                }
                var 
                    $resultContent = $result.wrapInner('<div></div>').children(),
                    oldHeight = $container.outerHeight(),
                    $content = $container.wrapInner('<div></div>').children(),
                    newHeight,
                    resultReplace = function(){
                        $container.html($resultContent.html());
                        $resultContent.remove();
                    };
                $container.css({
                    height: oldHeight,
                    'overflow-y': 'hidden'
                }).append($resultContent);
                newHeight = $resultContent.outerHeight();
                $container.animate({
                    height: newHeight
                }, o.duration, function(){
                    $container.css('height', '');
                    $container.css('overflow-y', '');
                });
                if(pollsL10n.show_fading) {
                    $resultContent
                        .css({opacity: 0.25})
                        .animate({ opacity: 1 }, o.duration );
                    $content.animate({
                            opacity : 0.25,
                            'margin-top' : '-' + oldHeight
                        }, o.duration, function(){
                            resultReplace();
                    });
                }else{
                    resultReplace();
                }
            }
        });
    }

};

B.web.onReady['polls'] = function(){
    $('[data-polls-vote]').click(function(){
        B.web.polls.vote($(this).data('polls-vote'));
    });

    $('#vote_polls').click(function(){
        // var ids = [];
        // // var findPollIds=function(){
        // // };
        // var $polls = $('form.wp-polls-form');
        // $polls.each(function(){
        //     ids.push($(this).attr('id').replace('polls_form_', ''));
        // });
        B.web.polls.voteAll();
        // vote_polls();
        var kk=1;
    });
};

})(jQuery, Bajt);
